<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="List of Abbreviations">
<p class="h1" id="ch-5"><span class="right_1" epub:type="pagebreak" id="page_xv" title="xv"><a href="#/text/9780253044174_Contents#ch5"><b>LIST OF ABBREVIATIONS</b></a></span></p>
<table>
<tbody><tr>
<td class="glo">AA</td>
<td class="glo1">Anti-Aircraft</td></tr>
<tr>
<td class="glo">ABDACOM</td>
<td class="glo1">American, British, Dutch, and Australian Command; code name for Supreme Allied Headquarters South-West Pacific from 15 January 1942.</td></tr>
<tr>
<td class="glo">AIF</td>
<td class="glo1">Australian Imperial Force</td></tr>
<tr>
<td class="glo">AIML</td>
<td class="glo1">All India Muslim League</td></tr>
<tr>
<td class="glo">AOC</td>
<td class="glo1">Air Officer Commanding</td></tr>
<tr>
<td class="glo">ARP</td>
<td class="glo1">Air Raid Precaution</td></tr>
<tr>
<td class="glo">A/T</td>
<td class="glo1">Antitank</td></tr>
<tr>
<td class="glo">AWM</td>
<td class="glo1">Australian War Memorial</td></tr>
<tr>
<td class="glo">BAR</td>
<td class="glo1">Browning Automatic Rifle</td></tr>
<tr>
<td class="glo">BL</td>
<td class="glo1">British Library</td></tr>
<tr>
<td class="glo">BOR</td>
<td class="glo1">British Other Rank</td></tr>
<tr>
<td class="glo">CAS</td>
<td class="glo1">Close Air Support</td></tr>
<tr>
<td class="glo">C3I</td>
<td class="glo1">Command, Control, Communications, and Intelligence</td></tr>
<tr>
<td class="glo">CIGS</td>
<td class="glo1">Chief of the Imperial General Staff</td></tr>
<tr>
<td class="glo">CO</td>
<td class="glo1">Commanding Officer</td></tr>
<tr>
<td class="glo">CoSC</td>
<td class="glo1">Chiefs of Staff Committee</td></tr>
<tr>
<td class="glo">CP</td>
<td class="glo1">Cabinet Papers</td></tr>
<tr>
<td class="glo">EBO</td>
<td class="glo1">Effects Based Operation</td></tr>
<tr>
<td class="glo">ECIO</td>
<td class="glo1">Emergency Commissioned Indian Officer</td></tr>
<tr>
<td class="glo">ECO</td>
<td class="glo1">Emergency Commissioned Officer</td></tr>
<tr>
<td class="glo">FFR</td>
<td class="glo1">Frontier Force Rifles</td></tr>
<tr>
<td class="glo">FOO</td>
<td class="glo1">Forward Observation Officer</td></tr>
<tr>
<td class="glo">GHQ</td>
<td class="glo1">General Headquarters</td></tr>
<tr>
<td class="glo">GOC</td>
<td class="glo1">General Officer Commanding</td></tr>
<tr>
<td class="glo">GoI</td>
<td class="glo1">Government of India</td></tr>
<tr>
<td class="glo">GR</td>
<td class="glo1">Gurkha Rifles</td></tr>
<tr>
<td class="glo">GSO</td>
<td class="glo1">General Staff Officer</td></tr>
<tr>
<td class="glo">ICO</td>
<td class="glo1">Indian Commissioned Officer</td></tr>
<tr>
<td class="glo">IIL</td>
<td class="glo1">Indian Independence League</td></tr>
<tr>
<td class="glo">IJA</td>
<td class="glo1">Imperial Japanese Army</td></tr>
<tr>
<td class="glo">IJN</td>
<td class="glo1">Imperial Japanese Navy</td></tr>
<tr>
<td class="glo">INA</td>
<td class="glo1">Indian National Army</td></tr>
<tr>
<td class="glo">INC</td>
<td class="glo1">Indian National Congress</td></tr>
<tr>
<td class="glo"><span class="right_1" epub:type="pagebreak" id="page_xvi" title="xvi">IOR</span></td>
<td class="glo1">India Office Records</td></tr>
<tr>
<td class="glo">IWM</td>
<td class="glo1">Imperial War Museum</td></tr>
<tr>
<td class="glo">JAAF</td>
<td class="glo1">Japanese Army Air Force</td></tr>
<tr>
<td class="glo">JNAF</td>
<td class="glo1">Japanese Navy Air Force</td></tr>
<tr>
<td class="glo">KCIO</td>
<td class="glo1">King’s Commissioned Indian Officer</td></tr>
<tr>
<td class="glo">LMG</td>
<td class="glo1">Light Machine Gun</td></tr>
<tr>
<td class="glo">LoC</td>
<td class="glo1">Line of Communication</td></tr>
<tr>
<td class="glo">MODHS</td>
<td class="glo1">Ministry of Defence Historical Section</td></tr>
<tr>
<td class="glo">MS</td>
<td class="glo1">Milestone</td></tr>
<tr>
<td class="glo">NAI</td>
<td class="glo1">National Archives of India</td></tr>
<tr>
<td class="glo">NAM</td>
<td class="glo1">National Army Museum</td></tr>
<tr>
<td class="glo">NCO</td>
<td class="glo1">Noncommissioned Officer</td></tr>
<tr>
<td class="glo">NMML</td>
<td class="glo1">Nehru Memorial Museum and Library</td></tr>
<tr>
<td class="glo">OIOC</td>
<td class="glo1">Oriental and India Office Collection</td></tr>
<tr>
<td class="glo">OR</td>
<td class="glo1">Other Rank/Private</td></tr>
<tr>
<td class="glo">OTU</td>
<td class="glo1">Officer Training Unit</td></tr>
<tr>
<td class="glo">PoW</td>
<td class="glo1">Prisoner of War</td></tr>
<tr>
<td class="glo">PRO</td>
<td class="glo1">Public Record Office</td></tr>
<tr>
<td class="glo">PWD</td>
<td class="glo1">Public Works Department</td></tr>
<tr>
<td class="glo">RA</td>
<td class="glo1">Royal Artillery</td></tr>
<tr>
<td class="glo">RAAF</td>
<td class="glo1">Royal Australian Air Force</td></tr>
<tr>
<td class="glo">RAF</td>
<td class="glo1">Royal Air Force</td></tr>
<tr>
<td class="glo">RE</td>
<td class="glo1">Royal Engineers</td></tr>
<tr>
<td class="glo">RGR</td>
<td class="glo1">Royal Garwahl/Garhwal Rifles</td></tr>
<tr>
<td class="glo">RN</td>
<td class="glo1">Royal Navy</td></tr>
<tr>
<td class="glo">RR</td>
<td class="glo1">Rajputana Rifles</td></tr>
<tr>
<td class="glo">SLoC</td>
<td class="glo1">Sea Line of Communication</td></tr>
<tr>
<td class="glo">VCO</td>
<td class="glo1">Viceroy’s Commissioned Officer</td></tr>
</tbody></table>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xvii" title="xvii"><img alt="Map 1: Far East Asia" src="images/map1.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map1"><a href="#/text/9780253044174_Maps#rmap1">Map 1: Far East Asia</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xviii" title="xviii"><img alt="Map 2: Proposed Sites for the Naval Base" src="images/map2.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map2"><a href="#/text/9780253044174_Maps#rmap2">Map 2: Proposed Sites for the Naval Base</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xix" title="xix"><img alt="Map 3: Malaya" src="images/map3.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map3"><a href="#/text/9780253044174_Maps#rmap3">Map 3: Malaya</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xx" title="xx"><img alt="Map 4: Japanese Advance in the Malayan Peninsula" src="images/map4.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map4"><a href="#/text/9780253044174_Maps#rmap4">Map 4: Japanese Advance in the Malayan Peninsula</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxi" title="xxi"><img alt="Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941" src="images/map5.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map5"><a href="#/text/9780253044174_Maps#rmap5">Map 5: Japanese Attack on Northern Malaya, 7/8 December 1941</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxii" title="xxii"><img alt="Map 6: Kota Bahru, 8 December 1941" src="images/map6.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map6"><a href="#/text/9780253044174_Maps#rmap6">Map 6: Kota Bahru, 8 December 1941</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxiii" title="xxiii"><img alt="Map 7: Jitra" src="images/map7.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map7"><a href="#/text/9780253044174_Maps#rmap7">Map 7: Jitra</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxiv" title="xxiv"><img alt="Map 8: WESTFORCE Disposition in Johore, 14 January 1942" src="images/map8.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map8"><a href="#/text/9780253044174_Maps#rmap8">Map 8: WESTFORCE Disposition in Johore, 14 January 1942</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxv" title="xxv"><img alt="Map 9: Northern Johore, 15 January 1942" src="images/map9.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map9"><a href="#/text/9780253044174_Maps#rmap9">Map 9: Northern Johore, 15 January 1942</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxvi" title="xxvi"><img alt="Map 10: Johore Bahru, January 1942" src="images/map10.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map10"><a href="#/text/9780253044174_Maps#rmap10">Map 10: Johore Bahru, January 1942</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxvii" title="xxvii"><img alt="Map 11: Disposition of Troops on Singapore Island, 8 February 1942" src="images/map11.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map11"><a href="#/text/9780253044174_Maps#rmap11">Map 11: Disposition of Troops on Singapore Island, 8 February 1942</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxviii" title="xxviii"><img alt="Map 12: Japanese Attack, Singapore, February 1942" src="images/map12.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map12"><a href="#/text/9780253044174_Maps#rmap12">Map 12: Japanese Attack, Singapore, February 1942</a></p>
<figure>
<p class="image"><span class="right_1" epub:type="pagebreak" id="page_xxix" title="xxix"><img alt="Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore" src="images/map13.jpg" style="width:100%;"/></span></p>
</figure>
<p class="caption" id="map13"><a href="#/text/9780253044174_Maps#rmap13">Map 13: The Japanese Assault and Advance and the Final Defense of the Perimeter, Singapore<span class="right_1" epub:type="pagebreak" id="page_xxx" title="xxx"></span></a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Abbreviations.vue?59c2c6f8